function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { T } from 'shared/helper/translate';
import { trackUseRubriqInWordClicked } from 'researcher/helpers/mixpanelEvents';
import { RUBRIQ_PLAN_NAMES_MAP } from '../constants';
import EditingImage from '../images/file-pen-duotone.svg';
import RubriqEditingStatus from './RubriqEditingStatus';
import WordAddinModal from './WordAddinModal';
var RubriqNoEditsMessage = function RubriqNoEditsMessage(_ref) {
  var _curie$plans$premium, _curie$plans, _premium$planName, _digitalEdit$digitalE, _digitalEdit$digitalE2, _curie$plan$subscript2, _curie$plan2;
  var loadingCheckDocumentModal = _ref.loadingCheckDocumentModal,
    onCheckDocument = _ref.onCheckDocument;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wordAddinModalOpen = _useState2[0],
    setWordAddinModalOpen = _useState2[1];
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie,
    user = _useSelector.user,
    digitalEdit = _useSelector.digitalEdit;
  var premium = (_curie$plans$premium = curie === null || curie === void 0 || (_curie$plans = curie.plans) === null || _curie$plans === void 0 ? void 0 : _curie$plans.premium) !== null && _curie$plans$premium !== void 0 ? _curie$plans$premium : {};
  var rawPlanName = (_premium$planName = premium.planName) !== null && _premium$planName !== void 0 ? _premium$planName : null;
  var formattedPlanName = RUBRIQ_PLAN_NAMES_MAP[rawPlanName] || rawPlanName;
  if ((premium === null || premium === void 0 ? void 0 : premium.paymentStatus) === 'trialing') {
    formattedPlanName = "".concat(formattedPlanName, " (Trial)");
  }
  var hasActivePlan = !!(premium !== null && premium !== void 0 && premium.planName);
  var label = ((_digitalEdit$digitalE = digitalEdit === null || digitalEdit === void 0 || (_digitalEdit$digitalE2 = digitalEdit.digitalEdits) === null || _digitalEdit$digitalE2 === void 0 ? void 0 : _digitalEdit$digitalE2.length) !== null && _digitalEdit$digitalE !== void 0 ? _digitalEdit$digitalE : 0) > 0 ? 'Post doc upload' : 'Empty state';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center gap-4 pt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center",
    style: {
      maxWidth: '400px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: EditingImage,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-4 mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start improving your writing"
  })), /*#__PURE__*/React.createElement("span", {
    className: "mt-2 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.no-edited-documents"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn btn-primary mt-4 rounded-3",
    onClick: function onClick() {
      return onCheckDocument();
    },
    disabled: loadingCheckDocumentModal
  }, /*#__PURE__*/React.createElement(T, {
    source: "check document"
  }), loadingCheckDocumentModal && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn bg-white fw-bold rounded-2 px-3 text-nowrap d-flex align-items-center gap-2 rubriq-word-button rubriq-word-button-no-edits",
    onClick: function onClick() {
      var _curie$plan$subscript, _curie$plan;
      trackUseRubriqInWordClicked({
        userAddinStatus: (user === null || user === void 0 ? void 0 : user.userAddinStatus) === 'true' ? 'installed' : 'not_installed',
        planName: formattedPlanName !== null && formattedPlanName !== void 0 ? formattedPlanName : 'No active plan',
        billingCycle: (_curie$plan$subscript = curie === null || curie === void 0 || (_curie$plan = curie.plan) === null || _curie$plan === void 0 ? void 0 : _curie$plan.subscriptionInterval) !== null && _curie$plan$subscript !== void 0 ? _curie$plan$subscript : 'No active plan',
        hasActivePlan: hasActivePlan !== null && hasActivePlan !== void 0 ? hasActivePlan : 'false',
        label: label
      });
      setWordAddinModalOpen(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "word-btn-icon"
  }, "W"), /*#__PURE__*/React.createElement(T, {
    source: "USE RUBRIQ IN WORD"
  }))), /*#__PURE__*/React.createElement(RubriqEditingStatus, {
    isNoEditsMessage: true
  })), /*#__PURE__*/React.createElement(WordAddinModal, {
    open: wordAddinModalOpen,
    onClose: function onClose() {
      return setWordAddinModalOpen(false);
    },
    userAddinStatus: (user === null || user === void 0 ? void 0 : user.userAddinStatus) === 'true' ? 'installed' : 'not_installed',
    planName: formattedPlanName !== null && formattedPlanName !== void 0 ? formattedPlanName : 'No active plan',
    billingCycle: (_curie$plan$subscript2 = curie === null || curie === void 0 || (_curie$plan2 = curie.plan) === null || _curie$plan2 === void 0 ? void 0 : _curie$plan2.subscriptionInterval) !== null && _curie$plan$subscript2 !== void 0 ? _curie$plan$subscript2 : 'No active plan',
    hasActivePlan: hasActivePlan
  }));
};
export default RubriqNoEditsMessage;